import { LEGACY_URL } from 'config'
import { getProductById } from 'services/product'
import { currentUserSelector, isTrialActiveSelector } from 'services/users/selectors'
import { CURRENCY_SIGN_MAP, LIMIT_PROFILES_COUNT, LIMIT_USERS_COUNT, User, PPProduct } from 'shared'
import { getState, StoreThunkDispatch } from 'store/state'
import capitalize from 'utils/format/capitalize'

export function mapAccountResponse(response: any) {
  return (dispatch: StoreThunkDispatch, getState: getState) => {
    const state = getState()
    const user = currentUserSelector(state) as User
    const account = response.account
    const isTrial = isTrialActiveSelector(state)
    const trialEndsAt = account.trialEndsAt || account.trialEndedAt
    const productInfo = dispatch(getProductById(account.product)) as PPProduct
    const isAnnualPlan = Boolean(account.isAnnual)

    const card = account.card
    const profile = response.profile
    const creditCard = card ? {
      ownerName: `${card.firstName} ${card.lastName}`,
      type: card.cardType,
      expirationMonth: card.expirationMonth,
      expirationYear: card.expirationYear
    } : undefined
    // eslint-disable-next-line no-magic-numbers
    const annualPricePerMonth = (productInfo.price.annual[user.account.currency] / 12).toFixed(2).replace('.00', '')
    const monthlyPrice = isAnnualPlan
      ? `${CURRENCY_SIGN_MAP[user.account.currency]}${annualPricePerMonth}/mo`
      : `${CURRENCY_SIGN_MAP[user.account.currency]}${productInfo.price.monthly[user.account.currency]}/mo`
    const name = `${capitalize(productInfo.name)} ${isTrial ? '(Trial)' : ''}`
    const description = productInfo.order > 0 // do not show description for Free plan
      ? `${name}: ${monthlyPrice} billed ${isAnnualPlan ? 'yearly' : 'monthly'}`
      : name

    const customProfilesLimit = account.profilesLimit
    const planProfilesLimit = productInfo.limits[LIMIT_PROFILES_COUNT]
    const useCustomProfilesLimit = customProfilesLimit && customProfilesLimit > planProfilesLimit

    const subscription = {
      name,
      description,
      masterAdmin: account.masterAdmin.toString(),
      usersLimit: productInfo.limits[LIMIT_USERS_COUNT],
      profilesLimit: useCustomProfilesLimit ? customProfilesLimit : planProfilesLimit,
      useCustomProfilesLimit,
      billingPortalLink: account.billingPortalLink,
      updatePaymentLink: `${LEGACY_URL}/settings/account_info/chargify_redirect?billing_portal_link=${account.billingPortalLink}`,
      chargifySubscriptionId: account.chargifySubscriptionId
    }

    return { profile, subscription, creditCard, productInfo, trialEndsAt, productDetails: account.productDetails }
  }
}

export function teamMemberAdapter(data: any) {
  let accounts = data.accounts || {}
  if (Array.isArray(data.accounts)) {
    accounts = data.accounts.reduce((map: any, acc: string) => {
      map[acc] = acc
      return map
    }, {})
  }

  const fbId = data.adminFbId || data.fbAccountId
  const photoUrl = fbId ? `//graph.facebook.com/${fbId}/picture?type=large` : undefined

  return {
    ...data,
    accounts,
    photoUrl,
    adminId: data.adminId || data.originalAdminId
  }
}
